import { FC } from 'react';
import Index1 from './assets/index1.svg';
import Index2 from './assets/index2.svg';
import Index3 from './assets/index3.svg';
import Index4 from './assets/index4.svg';
import Index5 from './assets/index5.svg';
import Index6 from './assets/index6.svg';
import Index7 from './assets/index7.svg';
import Index8 from './assets/index8.svg';
import Index9 from './assets/index9.svg';
import Index10 from './assets/index10.svg';

import './style.scss';

export const CardIndex: FC<{ index: number }> = ({ index }) => {
  let indexImg = null;
  switch (index) {
    case 0:
      indexImg = <Index1 />;
      break;
    case 1:
      indexImg = <Index2 />;
      break;
    case 2:
      indexImg = <Index3 />;
      break;
    case 3:
      indexImg = <Index4 />;
      break;
    case 4:
      indexImg = <Index5 />;
      break;
    case 5:
      indexImg = <Index6 />;
      break;
    case 6:
      indexImg = <Index7 />;
      break;
    case 7:
      indexImg = <Index8 />;
      break;
    case 8:
      indexImg = <Index9 />;
      break;
    case 9:
      indexImg = <Index10 />;
      break;
    default:
      indexImg = null;
  }
  return (
    indexImg && (
      <div key={`card-index-${index}}`} className="card-index">
        {indexImg}
      </div>
    )
  );
};
